<template>
  <div class="modal-out">
    <div class="modal">
      <div class="modal-header">
        <div style="padding: 6px;">编辑</div>
        <button type="button" class="btn-close" @click="closeSelf">X</button>
      </div>
      <div class="modal-body" style="max-height: 300px;">


        <el-row class="row">
          <el-col :span="12" class="item">
            <div class="label">图标</div>
            <el-upload
                action=""
                :limit="1"
                :on-preview="handlePictureCardPreview"
                :on-change="handleChange"
                :on-progress="onProgress"
                :on-success="imgSuccess"
                :on-error="imgError"
                :http-request="uploadHttp"
                list-type="picture-card"
                :on-remove="handleRemove"
                :class="{disabled:uploadDisabled}"
                :file-list="fileList">
              <i slot="default" class="el-icon-plus"></i>
            </el-upload>
            <el-dialog :modal-append-to-body="false" :visible.sync="imgVisible" width="30%">
              <img width="100%" :src="dialogImageUrl" alt="图片未找到"/>
            </el-dialog>

          </el-col>
          <el-col :span="12" class="item">
            <div class="label">志愿者人数</div>
            <el-input v-model="edit_volunteerCount" placeholder="请输入队伍人数"></el-input>
          </el-col>
        </el-row>

        <el-row class="row">
          <el-col :span="12" class="item">
            <div class="label">登录账号</div>
            <el-input v-model="edit_loginName" placeholder="请输入登录账号"></el-input>
          </el-col>
          <el-col :span="12" class="item">
            <div class="label">状态</div>
            <el-select v-model="edit_status" placeholder="请选择状态" @change="changeStatus" style="width:100%">
              <el-option
                  v-for="item in status2"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
              </el-option>
            </el-select>
          </el-col>
        </el-row>
        <el-row class="row">
          <el-col :span="12" class="item">
            <div class="label">手机号</div>
            <el-input v-model="edit_phone" placeholder="请输入手机号"></el-input>
          </el-col>
          <el-col :span="12" class="item">
            <div class="label">志愿队伍名称</div>
            <el-input v-model="edit_name" placeholder="请输入名称"></el-input>
          </el-col>
        </el-row>
        <el-row class="row">
          <el-col :span="24" class="item">
            <div class="label">地址</div>
            <el-input v-model="edit_address" placeholder="请输入地址"></el-input>
          </el-col>
        </el-row>
        <el-row class="row">
          <el-col :span="24" class="item">
            <div class="label">简介</div>
            <el-input v-model="edit_description" placeholder="请输入简介" type="textarea" :rows="5"></el-input>
          </el-col>
        </el-row>



      </div>
      <div class="modal-footer">
        <el-button @click.native="closeSelf">取消</el-button>
        <el-button :loading="loading"  type="primary" @click.native="confirm">确认</el-button>
      </div>
    </div>

  </div>
</template>


<script>

import {getStaffCode} from "@/utils/auth";
import {timeStr} from "@/common/times";
import {hex_md5} from "@/common/Base64MD5";

export default {
  name: 'Edit',
  props: [],
  data() {
    return {

      loading: false,

      edit_loginName:'',
      edit_name:'',
      edit_phone:'',
      edit_address:'',

      status2: [{
        value: 1,
        label: '正常'
      }, {
        value: 2,
        label: '禁用'
      }],
      edit_status: -1,

      volunteerTeamCode:'',

      edit_imgPath:'',
      edit_volunteerCount:0,
      edit_description:'',


      //上传身份证正面相关参数
      limitCount: 1,
      uploadDisabled: false,
      // 是否显示预览图片
      imgVisible: false,
      // 预览图片url
      dialogImageUrl: "",
      fileList: [],


    }
  },
  methods: {

    onProgress(event, file, fileList) {
      console.log(event,file,fileList);
      this.uploadDisabled = false;
    },
    // 图片上传成功
    imgSuccess(response, file, fileList) {
      console.log(response,file,fileList);
      this.uploadDisabled = true;
    },
    // 图片上传失败
    imgError(err, file, fileList) {
      console.log(err,file,fileList);
      this.uploadDisabled = true;
    },
    // 预览图片
    handlePictureCardPreview(file) {
      this.imgVisible = true;
      this.uploadDisabled = true;
      this.dialogImageUrl = file.url;
    },
    // 删除图片
    handleRemove(file, fileList) {
      console.log(file,fileList);
      this.uploadDisabled = false;
    },
    //图片更改
    handleChange(fileList) {
      this.uploadDisabled = fileList.length >= this.limitCount;
      this.uploadDisabled = true;
    },

    uploadHttp(file) {

      //获取文件信息
      //let fileLen = file.file;
      //let name = fileLen.name

      let fd = new FormData();
      fd.append('file',file.file);
      fd.append('staffCode',getStaffCode());
      fd.append('timeStr',timeStr);
      fd.append('sign',hex_md5("timeStr=" + timeStr + "&key="+this.$signKey));
      let that = this;
      this.$axios.post(this.$shopUrl+'Upload/Imgs',fd).then(function(res){
        console.log(res.data);
        that.edit_imgPath = that.$imgUrl+res.data.data.path;
      })


    },

    init(row){


      if(row.imgPath != '' && row.imgPath !=null){

        let obj = new Object();
        obj.url = this.$imgUrl+row.imgPath;

        this.edit_imgPath = this.$imgUrl+row.imgPath;

        this.fileList = [];
        this.fileList.push(obj);
        this.uploadDisabled= true;
      }else{
        this.fileList = [];
        this.uploadDisabled = false;
        this.edit_imgPath = "";
      }

      this.edit_loginName = row.loginName;
      this.edit_name = row.name;
      this.edit_phone = row.phone;
      this.edit_status = row.status;
      this.edit_address = row.address;
      this.edit_volunteerCount = row.volunteerCount;
      this.edit_description = row.description;

      this.volunteerTeamCode = row.volunteerTeamCode;

    },

    closeSelf() {
      this.loading= false
      this.$emit("closeEdit");
    },

    confirm(){

      if(this.edit_loginName === ''){
        this.$message("输入登录账号");
        return;
      }
      if(this.edit_name === ''){
        this.$message("输入名称");
        return;
      }
      if(this.edit_phone === ''){
        this.$message("输入手机号");
        return;
      }
      if(this.edit_address === ''){
        this.$message("输入地址");
        return;
      }

      if(this.edit_status === -1){
        this.$message("选择状态");
        return;
      }



      if(this.loading){
        return;
      }else{
        this.loading = true;
      }
      this.$axios({
        method: 'post',
        url: this.$shopUrl+'VolunteerTeam/Edit',
        data: {
          timeStr:timeStr,
          sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
          staffCode: getStaffCode(),
          name: this.edit_name,
          loginName:this.edit_loginName,
          status:this.edit_status,
          phone:this.edit_phone,
          address:this.edit_address,
          volunteerCount:this.edit_volunteerCount,
          description:this.edit_description,
          volunteerTeamCode:this.volunteerTeamCode,
          imgPath:this.edit_imgPath.replace(this.$imgUrl,""),
        }
      }).then( (response)=> {
        //console.log(response)
        this.loading = false;
        if(response.data.error == 0){
          this.$emit("closeEdit");
          this.$emit("getList");
        }else{
          this.$message(response.data.message);
        }

      }).catch(function (error) {
        console.log(error);
      });

    },


    changeStatus:function (selVal) {
      this.edit_status = selVal;
    },



  }
}
</script>


<style>
.disabled .el-upload--picture-card {
  display: none;
}
</style>